import { SuperInputBase } from "@components:SuperInput/SuperInput.Base";
import { SuperInputProps } from "@components:SuperInput/types";
import { TextField, TextFieldProps } from "@mui/material";
import { mergeObjects } from "@utils:object";

export type SuperInputNumberFieldProps = SuperInputProps &
  Omit<TextFieldProps, "type" | "inputProps"> & {
    width?: string;
    min?: number;
    max?: number;
    step?: number;
  };

export const SuperInputNumberField = ({
  label,
  helperText,
  explainText,
  errorText,
  sx,
  width,
  required,
  autoHeight,
  min,
  max,
  step,
  ...props
}: SuperInputNumberFieldProps) => {
  return (
    <SuperInputBase
      autoHeight={autoHeight}
      label={label}
      helperText={helperText}
      explainText={explainText}
      errorText={errorText}
      required={required}
      sx={sx}
    >
      <TextField
        {...props}
        type="number"
        className="SuperInput__TextField SuperInput__NumberField with-bg"
        slotProps={mergeObjects(
          {
            htmlInput: {
              ...(min !== undefined && { min }),
              ...(max !== undefined && { max }),
              ...(step !== undefined && { step }),
            },
          },
          props.slotProps,
        )}
        sx={{
          width: width ?? "100%",
        }}
      />
    </SuperInputBase>
  );
};
